export default function GeneralQueryIcon({ width = 32, height = 32 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10V26C36 31.5228 31.5228 36 26 36H10C4.47715 36 0 31.5228 0 26V10Z'
        fill='#FFFBEB'
      />
      <mask
        id='mask0_23892_48797'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='8'
        y='8'
        width='20'
        height='20'
      >
        <rect x='8' y='8' width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_23892_48797)'>
        <path
          d='M17.9966 24.538L12.5799 21.5957V17.0765L9.69531 15.4996L17.9966 10.9805L26.2978 15.4996V21.4932H25.0478V16.1919L23.4132 17.0765V21.5957L17.9966 24.538ZM17.9966 18.583L23.697 15.4996L17.9966 12.4163L12.2961 15.4996L17.9966 18.583ZM17.9966 23.1151L22.1632 20.8651V17.7432L17.9966 20.0173L13.8299 17.7432V20.8651L17.9966 23.1151Z'
          fill='#D97706'
        />
      </g>
    </svg>
  );
}
